module.exports = __webpack_public_path__ + "static/media/13-learning_good_consent.4c428a87.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/13-learning_good_consent.pdf
// module id = 165
// module chunks = 0